module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-modal', {
    ref: "missionSlotTemplateSlotGroupCreateModal",
    attrs: {
      "id": "missionSlotTemplateSlotGroupCreateModal",
      "title": _vm.$t('mission.modal.slotGroup.create'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.clearMissionSlotTemplateSlotGroupCreateData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.addMissionSlotTemplateSlotGroup($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slotGroup.title'),
      "state": _vm.missionSlotTemplateSlotGroupCreateTitleState,
      "feedback": _vm.missionSlotTemplateSlotGroupCreateTitleFeedback,
      "description": _vm.$t('mission.slotGroup.title.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.missionSlotTemplateSlotGroupCreateData.title),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotGroupCreateData.title = $$v
      },
      expression: "missionSlotTemplateSlotGroupCreateData.title"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slotGroup.description.optional'),
      "state": "success",
      "description": _vm.$t('mission.slotGroup.description.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionSlotTemplateSlotGroupCreateData.description),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotGroupCreateData.description = $$v
      },
      expression: "missionSlotTemplateSlotGroupCreateData.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slotGroup.insertAfter'),
      "state": "success",
      "description": _vm.$t('mission.slotGroup.insertAfter.description')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.missionSlotTemplateSlotGroupCreateInsertAfterOptions
    },
    model: {
      value: (_vm.missionSlotTemplateSlotGroupCreateData.insertAfter),
      callback: function($$v) {
        _vm.missionSlotTemplateSlotGroupCreateData.insertAfter = $$v
      },
      expression: "missionSlotTemplateSlotGroupCreateData.insertAfter"
    }
  })], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission slot template slot group create actions"
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.addMissionSlotTemplateSlotGroup
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.submit')) + "\n        ")]), _vm._v(" "), _c('b-btn', {
    on: {
      "click": _vm.hideMissionSlotTemplateSlotGroupCreateModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67720e92"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missionSlotTemplates/modals/MissionSlotTemplateSlotGroupCreateModal.vue
// module id = 541
// module chunks = 0